<template>
    <div>
        <div
            v-if="withSearch || withFilter"
            class="kgr-row"
        >
            <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
                <div
                    v-if="withSearch"
                    class="kgr-grid__cell"
                >
                    <label class="kgr-inputGroup">
                        <div
                            v-t="'search'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <input
                            v-model="search"
                            type="text"
                            class="kgr-input"
                        />
                    </label>
                </div>
                <div
                    v-if="withFilter"
                    class="kgr-grid__cell"
                >
                    <label class="kgr-inputGroup">
                        <div
                            v-t="'Kategorien'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <kgr-multi-select
                            v-model="selectedCategories"
                            :options="filteredCategories"
                            display="name"
                            searchable
                        />
                    </label>
                </div>
            </div>
        </div>
        <table
            vue:is="kgr-table"
            class="kgr-table kgr-table--striped kgr-table--block"
            :is-data-table="isDataTable"
            searching="false"
        >
            <thead>
                <tr class="kgr-table__row">
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        sortable
                    >
                        {{ $t('Name') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        sortable
                    >
                        {{ $t('Sachkonto') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                        sortable
                    >
                        {{ $t('Kategorie') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        v-if="isAggregated"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Anzahl') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Preis') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('lädt Guthaben auf') }}
                    </th>
                    <th
                        vue:is="kgr-th"
                        v-if="hasAction"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ $t('Aktion') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in items"
                    :key="item.id"
                    class="kgr-table_row"
                >
                    <td class="kgr-table__cell">
                        {{ item.name }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ item.impersonalAccount ? item.impersonalAccount.showLabel() : '' }}
                    </td>
                    <td class="kgr-table__cell">
                        {{ item.category.name }}
                    </td>
                    <td
                        v-if="isAggregated"
                        class="kgr-table__cell"
                    >
                        {{ item.count }}
                    </td>
                    <td class="kgr-table__cell">
                        <kgr-price
                            :price="item.pricePerTime"
                            with-vat
                        />
                    </td>
                    <td class="kgr-table__cell">
                        <div
                            v-if="item.chargeCredit"
                            class="icon-check"
                        ></div>
                    </td>
                    <td
                        v-if="hasAction"
                        class="kgr-table__cell"
                    >
                        <slot
                            name="action"
                            :item="item"
                        ></slot>
                    </td>
                </tr>
                <tr v-if="withTotalPrice && clubSalesListItems.length > 0">
                    <td
                        class="kgr-table__cell"
                        :colspan="isAggregated ? 4 : 3"
                    ></td>
                    <td class="kgr-table__cell">
                        {{ totalPrice }}
                    </td>
                </tr>
                <tr v-if="clubSalesListItems.length === 0">
                    <td
                        class="kgr-table__cell"
                        :colspan="isAggregated ? 6 : 5"
                    >
                        {{ noItemsText }}
                    </td>
                </tr>
            </tbody>
        </table>
        <kgr-paginator
            v-if="withPagination"
            v-model="paginator"
            :length="filteredItems.length"
        />
    </div>
</template>

<script>
import MultiSelect from '../../common/form/select/MultiSelect.vue';
import Paginator from '../../common/Paginator.vue';
import PricePerTimeOutput from './PricePerTimeOutput.vue';

export default {
    components: {
        'kgr-price': PricePerTimeOutput,
        'kgr-paginator': Paginator,
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clubSalesListItems: {
            type: Array,
            required: true,
        },
        categories: {
            type: Array,
            required: false,
            default: () => [],
        },
        hasAction: {
            type: Boolean,
            required: false,
            default: false,
        },
        isAggregated: {
            type: Boolean,
            required: false,
            default: false,
        },
        withTotalPrice: {
            type: Boolean,
            required: false,
            default: false,
        },
        withSearch: {
            type: Boolean,
            required: false,
            default: false,
        },
        withPagination: {
            type: Boolean,
            required: false,
            default: false,
        },
        withFilter: {
            type: Boolean,
            required: false,
            default: false,
        },
        isEditable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            search: '',
            selectedCategories: [],
            initialPaginator: null,
            paginator: null,
        };
    },
    computed: {
        noItemsText() {
            if (this.isAggregated) {
                return this.$t('Keine Artikel vorhanden');
            }
            return this.$t('Keine Beiträge vorhanden');
        },
        isDataTable() {
            return !(this.withTotalPrice || this.isAggregated || this.withSearch || this.withFilter) && this.filteredItems.length > 0;
        },
        searchString() {
            return this.search.trim().toLowerCase();
        },
        filteredCategories() {
            return this.categories.filter((c) => this.selectedCategories.indexOf(c) === -1);
        },
        totalPrice() {
            let totalPrice = 0;
            this.clubSalesListItems.forEach((item) => {
                totalPrice += item.pricePerTime.gross.numerator / item.pricePerTime.gross.denominator;
            });
            return this.$t('Total: {totalPrice} € (inkl. MwSt.)', {
                totalPrice: totalPrice.toFixed(2).replace('.', ','),
            });
        },
        aggregatedItems() {
            const aggregatedItems = [];
            this.clubSalesListItems.forEach((item) => {
                if (aggregatedItems.filter((aggItem) => aggItem.id === item.id).length === 0) {
                    item.count = this.clubSalesListItems.filter((i) => i.id === item.id).length;
                    aggregatedItems.push(item);
                }
            });
            return aggregatedItems;
        },
        filteredItems() {
            let items;
            if (this.isAggregated) {
                items = this.aggregatedItems;
            } else {
                items = this.clubSalesListItems;
            }

            if (this.selectedCategories.length > 0) {
                items = items.filter((i) => this.selectedCategories.findIndex((e) => e.id === i.category.id) !== -1);
            }

            if (this.searchString.length > 0) {
                items = items.filter((item) => {
                    return item.name.toLowerCase().includes(this.searchString);
                });
            }

            return items;
        },
        items() {
            if (this.withPagination && this.paginator.limit) {
                const start = (this.paginator.offset);
                const end = start + this.paginator.limit;
                return this.filteredItems.slice(start, end);
            }
            return this.filteredItems;
        },
    },
    watch: {
        filteredCategories() {
            this.paginator = this.initialPaginator;
        },
        search() {
            this.paginator = this.initialPaginator;
        },
    },
    created() {
        const initialPaginator = {
            limit: 10,
            offset: 0,
        };
        this.initialPaginator = initialPaginator;
        this.paginator = initialPaginator;
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
